import {Box} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import ChartColumnMultiple from 'src/sections/_examples/extra/chart-view/chart-column-multiple';
import RCMDashboardTable from '../RCMDashboardTable';
import {fetchChartColors} from 'src/utils/chart_utils';

const RCMReSubmissionsComponent = ({data, chartData, ...props}: any) => {
  const [chartColors, setChartColors] = useState<any>({});
  const barChartRef = useRef<any>(null);
  const barChartRef_02 = useRef<any>(null);

  useEffect(() => {
    // Fetch colors after charts are rendered
    const refList: any = [
      {
        ref: barChartRef,
        type: 'bar',
        name: 'bar_chart_01'
      },
      {
        ref: barChartRef_02,
        type: 'bar',
        name: 'bar_chart_02'
      }
    ];
    setTimeout(() => {
      /** Function to retrieve chart colors */
      fetchChartColors(setChartColors, refList);
    }, 500);
  }, [chartData]);

  return (
    <>
      <ChartColumnMultiple
        chartRef={barChartRef}
        height={500}
        chartOptionsObj={{
          yaxis: {
            labels: {
              formatter: function (value: any) {
                return `$${value}`; // Add the dollar symbol before the value
              }
            },
            title: {
              text: 'Claim Amount' // Optional: Add a title for the y-axis
            }
          },
          plotOptions: {bar: {columnWidth: '80%'}},
          ...chartData?.bar_chart_01
        }}
        series={chartData?.bar_chart_01?.series ?? []}
      />
      {chartColors?.bar_chart_01 ? (
        <Box sx={{mt: 5}}>
          <RCMDashboardTable
            data={{
              ...chartData?.table_data_01,
              colors: chartColors?.bar_chart_01
            }}
            valueFormatter={'currency'}
          />
        </Box>
      ) : null}
      {chartData.bar_chart_02?.series ? (
        <Box sx={{mt: 15}}>
          <ChartColumnMultiple
            chartRef={barChartRef_02}
            //   height={500}
            chartOptionsObj={{
              yaxis: {
                labels: {
                  formatter: function (value: any) {
                    return `$${value}`; // Add the dollar symbol before the value
                  }
                },
                title: {
                  text: 'Resubmitted Claims Amount' // Optional: Add a title for the y-axis
                }
              },
              plotOptions: {bar: {columnWidth: '80%'}},
              ...chartData?.bar_chart_02
            }}
            series={chartData?.bar_chart_02?.series ?? []}
          />
          {chartData?.table_data_02 && chartColors?.bar_chart_02 ? (
            <Box sx={{mt: 5}}>
              <RCMDashboardTable
                data={{
                  ...chartData?.table_data_02,
                  colors: chartColors?.bar_chart_02
                }}
                valueFormatter={'currency'}
              />
            </Box>
          ) : null}
        </Box>
      ) : null}
    </>
  );
};

export default RCMReSubmissionsComponent;
